<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";

    import Icon from "@components/Icon.svelte";

    import { videoControllerToken } from "./context_tokens";
    import VideoPlayerVolume0 from "./icons/VideoPlayerVolume0.svelte";
    import VideoPlayerVolume1 from "./icons/VideoPlayerVolume1.svelte";
    import VideoPlayerVolume2 from "./icons/VideoPlayerVolume2.svelte";
    import VideoPlayerUIButton from "./VideoPlayerUIButton.svelte";
    import VideoPlayerUISlider from "./VideoPlayerUISlider.svelte";

    const videoController = getTypedContext(videoControllerToken);

    const currentVolume = videoController.currentVolume$;
    const toggleVolume = () => {
        if (currentVolume.getValue() > 0) {
            videoController.changeVolume(0);
        } else {
            videoController.changeVolume(1);
        }
    };
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ const changeVolume =
        (e: CustomEvent<any>) => {
            videoController.changeVolume(e.detail);
        };
</script>

<div class="gw-vp-volume">
    <VideoPlayerUIButton on:click={toggleVolume}>
        <Icon height="1.5rem" width="1.5rem">
            {#if $currentVolume > 0.5}
                <VideoPlayerVolume2 />
            {:else if $currentVolume > 0.0}
                <VideoPlayerVolume1 />
            {:else}
                <VideoPlayerVolume0 />
            {/if}
        </Icon>
    </VideoPlayerUIButton>
    <div class="gw-vp-volume__slider">
        <VideoPlayerUISlider
            on:change={changeVolume}
            max={1}
            value={$currentVolume}
        />
    </div>
</div>

<style>
    .gw-vp-volume {
        display: flex;
        align-items: center;
    }

    .gw-vp-volume__slider {
        width: 0px;
        margin-left: 3px;
        transition: width 0.3s;
    }

    .gw-vp-volume:hover .gw-vp-volume__slider {
        width: 100px;
    }
</style>
